(() => {
  window.tptcCurrencyPlusPlacementCleanup?.();
  const media = matchMedia('(max-width: 1199px)');
  const selector = 'span.currency-converter-currency-button';
  let button, drawer, discovery, discoveryTimer, buttonObserver, drawerObserver;
  let frame = 0;
  let disposed = false;
  const abort = new AbortController();
  function findDrawer() {
    return document.getElementById('header-component')?.querySelector('#Details-menu-drawer-container, .header__drawer, menu-drawer, details[id*="menu-drawer"]') ||
      document.querySelector('#Details-menu-drawer-container, menu-drawer, .menu-drawer');
  }
  function stopDiscovery() {
    discovery?.disconnect();
    discovery = null;
    clearTimeout(discoveryTimer);
  }
  function discover() {
    if (discovery || disposed || button?.isConnected || !document.body) return;
    discovery = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node =>
        node instanceof Element && (node.matches(selector) || node.querySelector(selector))
      ))) schedule();
    });
    discovery.observe(document.body, { childList: true, subtree: true });
    discoveryTimer = setTimeout(stopDiscovery, 30000);
  }
  function syncCode() {
    const image = button?.querySelector('img.cbb-currency-flag');
    if (!image) return;
    const alt = (image.getAttribute('alt') || '').trim().toUpperCase();
    const match = (image.getAttribute('src') || '').match(/\/([A-Z]{3})\.(?:png|svg|webp)(?:\?|$)/i);
    const code = /^[A-Z]{3}$/.test(alt) ? alt : match?.[1].toUpperCase();
    if (code && button.dataset.tptcCode !== code) button.dataset.tptcCode = code;
  }
  function place() {
    frame = 0;
    if (disposed) return;
    if (!button?.isConnected) {
      const candidates = [...document.querySelectorAll(selector)];
      const found = candidates.find(node => node.classList.contains('tptc-ccp-widget')) ||
        candidates.find(node => !node.closest('.currency-converter-currency-list, [role="listbox"]'));
      if (found !== button) {
        buttonObserver?.disconnect();
        button = found;
        if (button) {
          buttonObserver = new MutationObserver(syncCode);
          buttonObserver.observe(button, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'alt'] });
        }
      }
    }
    if (!button) { discover(); return; }
    stopDiscovery();
    const anchor = document.getElementById('tptc-currency-converter-anchor');
    if (!anchor) return;
    if (!button.classList.contains('tptc-ccp-widget')) button.classList.add('tptc-ccp-widget');
    syncCode();
    const nextDrawer = findDrawer();
    if (drawer !== nextDrawer) {
      drawerObserver?.disconnect();
      drawer = nextDrawer;
      if (drawer) {
        drawerObserver = new MutationObserver(() => {
          if (!button?.isConnected || (media.matches && button.parentElement?.id !== 'tptc-ccp-mobile-slot')) schedule();
        });
        drawerObserver.observe(drawer, { childList: true, subtree: true });
      }
    }
    if (media.matches) {
      const destination = drawer?.matches('.menu-drawer') ? drawer : drawer?.querySelector('.menu-drawer');
      if (!destination) return;
      let slot = document.getElementById('tptc-ccp-mobile-slot');
      if (!slot) {
        slot = document.createElement('div');
        slot.id = 'tptc-ccp-mobile-slot';
        slot.className = 'tptc-ccp-mobile-slot';
      }
      if (slot.parentElement !== destination) destination.prepend(slot);
      if (button.parentElement !== slot) slot.append(button);
    } else if (button.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', button);
  }
  function schedule() {
    if (!frame && !disposed) frame = requestAnimationFrame(place);
  }
  function onToggle(event) {
    if (event.target === findDrawer()) schedule();
  }
  document.addEventListener('toggle', onToggle, { capture: true, signal: abort.signal });
  document.addEventListener('shopify:section:load', schedule, { signal: abort.signal });
  window.addEventListener('load', schedule, { once: true, signal: abort.signal });
  media.addEventListener('change', schedule, { signal: abort.signal });
  schedule();
  window.tptcCurrencyPlusPlacementCleanup = () => {
    disposed = true;
    abort.abort();
    cancelAnimationFrame(frame);
    stopDiscovery();
    buttonObserver?.disconnect();
    drawerObserver?.disconnect();
  };
})();
